<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';

import PageHeader from '../../SettingsSubPageHeader.vue';

const { t } = useI18n();

const globalConfig = useMapGetter('globalConfig/get');

const items = computed(() => {
  const steps = ['CREATE', 'ASSIGN_INBOXES', 'FINISH'];

  const routes = {
    CREATE: 'wgpt_bots_new',
    ASSIGN_INBOXES: 'wgpt_bots_add_inboxes',
    FINISH: 'wgpt_bots_finish',
  };

  return steps.map(step => {
    return {
      title: t(`WGPT_BOTS.NEW_FLOW.WIZARD.${step}.TITLE`),
      body: t(`WGPT_BOTS.NEW_FLOW.WIZARD.${step}.BODY`),
      route: routes[step],
    };
  });
});
</script>

<template>
  <div class="mx-auto flex flex-col gap-6 mb-8 max-w-7xl w-full !px-6">
    <PageHeader class="block lg:hidden !mb-0" :header-title="pageTitle" />
    <div
      class="grid grid-cols-1 lg:grid-cols-8 lg:divide-x lg:divide-n-weak rounded-xl border border-n-weak h-full min-h-[50dvh]"
    >
      <woot-wizard
        class="hidden lg:block col-span-2 h-fit py-8 px-6"
        :global-config="globalConfig"
        :items="items"
      />
      <div class="col-span-6 flex flex-col overflow-y-auto">
        <router-view />
      </div>
    </div>
  </div>
</template>
